import { DefaultTheme } from "styled-components/macro";

const theme: DefaultTheme = {
    borderRadius: "5px",
    colors: {
        accent: {
            hyperlink: {
                backgroundColor: "#005C99",
                color: "#FFFFFF"
            },
            icon: {
                backgroundColor: "#FF013B",
                color: "#FFFFFF"
            }
        },
        neutral: {
            dark: {
                backgroundColor: "#4D4D4D",
                color: "#FFFFFF"
            },
            darker: {
                backgroundColor: "#1A1A1A",
                color: "#FFFFFF"
            },
            light: {
                backgroundColor: "#CCCCCC",
                color: "#4D4D4D"
            },
            lighter: {
                backgroundColor: "#F5F5F5",
                color: "#4D4D4D"
            },
            medium: {
                backgroundColor: "#666666",
                color: "#FFFFFF"
            }
        },
        primary: {
            dark: {
                backgroundColor: "#e77b85",
                color: "#dfdfdf"
            },
            deep: {
                backgroundColor: "#2A2D40",
                color: "#FFFFFF"
            },
            light: {
                backgroundColor: "#CFE5EB",
                color: "#000000"
            },
            main: {
                backgroundColor: "#4692A9",
                color: "#000000"
            },
            medium: {
                backgroundColor: "#9FCAD7",
                color: "#000000"
            }
        }
    }
};

export default theme;
